export default "__VITE_ASSET__AhbHqyV5__"